import React from "react";
import { AiFillCloseCircle } from "react-icons/ai";

function Badge({ onClose, title, index }) {
  const color = {    
    0: "border-green-500 bg-green-500 text-green-500",
    1: "border-yellow-600 bg-yellow-300 text-yellow-600",
    2: "border-indigo-500 bg-indigo-500 text-indigo-500",
    3: "border-red-500 bg-red-500 text-red-500",
    4: "border-purple-500 bg-purple-500 text-purple-500",
    5: "border-pink-500 bg-pink-500 text-pink-500",
  };

  const id = index % 6;
  
  return (
    <div className={`Badge px-2 py-1 flex gap-1 items-center rounded-2xl border-2 bg-opacity-5 ${color[id]}`} >
      <span className="text-sm font-semibold border-r pr-1 border-inherit">{title}</span>
      <AiFillCloseCircle onClick={() => onClose(title)} className="cursor-pointer" />
    </div>
  );
}

export default Badge;
